export enum Campaigns {
  MOONSHOT = 'moonshot',
}

export enum MoonshotSteps {
  CREATE_TEAM = 'create-team',
  INVITE = 'invite',
  PAYMENT = 'payment',
  PAYMENT_FORM = 'payment-form',
  SUCCESS = 'success',
  WELCOME = 'welcome',
}
